export const DotwRedesignStyles = {
  fontFamily: "'proxima-nova', sans-serif",
  position: 'fixed',
  zIndex: 9999,

  '& .dotw-dialog-redesign__heading': {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: '0.55rem !important',
    lineHeight: '26px',
    letterSpacing: '1px',
  },

  '& .dotw-dialog-redesign__discount-text-title': {
    color: '#144B3C',
  },

  '& .dotw-dialog-redesign-button': {
    fontSize: '16px',
    marginTop: '15px',
    marginBottom: '10px',
  },

  '& .dotw-dialog-redesign__content': {
    textAlign: 'center',
  },

  '& .dotw-dialog-redesign__description': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '1px',
  },

  '& .dotw-dialog-redesign__description-subtitle': {
    fontSize: '1.14rem',
    fontWeight: 600,
    lineHeight: '22px',
  },

  '& .dotw-dialog-redesign-product__discount-text': {
    color: '#144B3C',
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '30px',
    letterSpacing: '1px',
  },

  '& .dotw-dialog-redesign-product__original-price': {
    textDecoration: 'line-through',
    marginLeft: '0.5em',
    color: '#999',
    fontSize: '0.9rem',
  },

  '& .dotw-dialog-redesign-product__discounted-price': {
    color: '#144B3C',
    marginLeft: '0.5em',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },

  '& .dotw-dialog-redesign-product': {
    margin: '2rem auto',
    display: 'flex',
    flexDirection: 'column',
  },

  '& .dotw-dialog-redesign-product__details': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '285px',
  },

  '& .dotw-dialog-redesign-product__image-container': {
    textAlign: 'center',
  },

  '& .dotw-dialog-redesign-product__name': {
    fontSize: '1.14rem',
  },

  '& .dotw-dialog-redesign-product__name-price-container': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '5px',
  },

  '& .dotw-dialog-redesign-product__prices': {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.75em',
  },

  '& .dotw-dialog-redesign-product__size': {
    fontSize: '1.14rem',
  },

  '& .dotw-dialog-redesign-product__delivery': {
    fontSize: '1.14rem',
  },

  '& .dotw-dialog-redesign-product__price': {
    fontSize: '1.14rem',
    fontWeight: 600,
  },

  '& .dotw-dialog-redesign-bouq-name': {
    marginBottom: '0.4em !important',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
  },

  '& .dotw-dialog-redesign-bouq-name__bold': {
    fontWeight: 'bold',
  },

  '& .italic-text': {
    fontStyle: 'italic',
  },

  '& .text-align-left-mobile': {
    textAlign: 'left',
  },
};
